import { useTranslation } from "react-i18next";
import SiteSummary from "../SiteSummary.tsx";
import { Link } from "react-router";
import Alert from "react-bootstrap/Alert";
import { useAppSelector } from "../../../../services/hooks.ts";

export default function SiteSummaryDetails() {
    const invoice = useAppSelector((state) => state.checkout.orderInvoice);

    return (
        <SiteSummary>
            {typeof invoice === 'string' && invoice.length && <SiteSummary.Button>
                <InvoiceButton url={invoice} />
            </SiteSummary.Button>}

            <SiteSummary.Footer>
                <OrderConfirmation />
            </SiteSummary.Footer>
        </SiteSummary>
    )
}

const InvoiceButton = ({ url }: { url: string }) => {
    const { t } = useTranslation('cart');

    return (
        <Link to={url} className="text-decoration-none text-white fs-5">
            <div>
                <strong>{t('summary.invoice_button')}</strong>
            </div>
        </Link>
    );
};

const OrderConfirmation = () => {
    const { t } = useTranslation('cart');
    //const status = useAppSelector((state) => state.checkout.orderStatus);

    //if(status && status > 1) return '';

    return (
        <Alert variant={'success'} className={'text-center mt-3'}>
            {t('summary.success_monit')}
        </Alert>
    );
}